module.exports = __webpack_public_path__ + "static/img/brees-2008-img-in-copy.cd87e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-img-in-copy.jpg
// module id = jIm+
// module chunks = 1